import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NewquestionModel } from 'src/app/models/assessment/newquestion.model';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ToastrService } from 'ngx-toastr';
import { QuestionOption } from 'src/app/models/assessment/questionoption.model';
import * as Quill from 'quill';
declare var $: any;
declare var toastr: any;
//declare var optionKey_:any;

@Component({
  selector: 'app-addquestion',
  templateUrl: './addquestion.component.html',
  styleUrls: ['./addquestion.component.css'],
})

export class AddquestionComponent implements OnInit, AfterViewInit {

  //actionTYpe { 100 : create, 200 : edit }
  questionData = {
    id: 0,
    text: "",
    options: "",
    marks: 0,
    sno: 0
  }
  isEdit: boolean;
  questionID = 0;
  optionKey_ = 'impt-qtn-options';
  readonly optionKey = 'impt-qtn-options';
  freezePage_formSubmissionInProgress = false;
  assessmentid: number;
  currentClassID: number;
  currentBatchID: number;
  QuestionTitle: string;
  QuestionType: string;

  headertext = "Add Question ";

  optionitemvalue: string;


  questionOptions: any = [];
  question: [QuestionOption[]];

  @ViewChild("test") setQuestionForPosting: ElementRef;
  @ViewChild("editor") editor: ElementRef;
  @ViewChild("marks") markField: ElementRef;
  @ViewChild("question") questionField: ElementRef;
  @ViewChild("saveModalOptions") saveModalOptions: ElementRef;
  @ViewChild("optionsHolder") optionsHolder: ElementRef;
  @ViewChild("optiondisplayPane") optiondisplayPane: ElementRef;
  @ViewChild("redirectflag") redirectflag: ElementRef;
  optionsSetup:number[] = [];


  constructor(private router: Router, private activiatedroute: ActivatedRoute, public assesmentmanager: AssessmentmanagerService, private header: ComponentheaderService, private toastr: ToastrService) {
    this.assessmentid = this.activiatedroute.snapshot.queryParams.aid;
    this.currentClassID = this.activiatedroute.snapshot.queryParams.classid;
    this.questionID = this.activiatedroute.snapshot.queryParams.qid;
    this.currentBatchID = this.activiatedroute.snapshot.queryParams.batchid;
    let actionType = this.activiatedroute.snapshot.queryParams.actiontype;
    if (actionType == 200) {
      this.isEdit = true;
      this.headertext = "Edit Question ";
    }
    header.setHeaderDisplay("New Question", [], []);
  }


  ngOnInit(): void {
    this.header.pageLoadingStarted(this);
    this.assesmentmanager.getAssessmentBreadCrumb(this.assessmentid).toPromise().then(
      (response: any) => {
        this.header.setHeaderDisplay(` ${response.assessmentName}: ${this.headertext}`,
          [
            { displaytext:  'School', route: `/user/schoolhome`, params: { schoolID: response.schoolID } },
            { displaytext:  'Course', route: `/user/moduledetails`, params: { moduleID: response.moduleID } },
            { displaytext:  'Lesson' , route: `/user/lesson`, params: { classid: this.currentClassID } },
            { displaytext: "Assessments", route: `/user/assessmentconsole`, params: { classid: this.currentClassID, batchid:this.currentBatchID, } },
            { displaytext: response.assessmentName, route: `/user/assessmentdetails`, params: { classid: this.currentClassID, batchid:this.currentBatchID, aid: this.assessmentid } },
            { displaytext: this.headertext, route: `/user/addquestion`, params: { classid: this.currentClassID, aid: this.assessmentid, target: 2 } }
          ],
          []);
      }
    );
    this.QuestionType = localStorage.getItem("qtype");
    this.QuestionTitle = localStorage.getItem("atitle");

    if (this.QuestionType == this.assesmentmanager.QuestionTypeFlags.multichoiceQuestionFlag && !this.isEdit) {
      this.questionData.marks = 1;
    }

    let rph = this.removePlaceHolder;

    localStorage.removeItem(this.optionKey);

    this.optionKey_ = this.optionKey;

    if (this.isEdit && this.questionID > 0) {
      //fetch the question and fill the question data with the retrieved details
      this.assesmentmanager.getAssessmentQuestion(this.questionID).toPromise().then(
        (data: any) => {
          //debugger;
          this.questionData.text = data.text;
          this.questionData.id = data.id;
          this.questionData.marks = data.marks;
          this.questionData.sno = data.sno;
          this.questionOptions = data.editoptions;
        }

      ).finally(() => {
        //debugger;
        this.header.pageLoadingDone(this);
      });
    }
    else{
      this.header.pageLoadingDone(this);
    }

    $('#clear-options').click(function (e) {
      let content: string = $(".ql-editor").html();
      let indexToRemove: number = content.lastIndexOf("_");
      let updatedcontent = rph(content, indexToRemove, "");

      $(".ql-editor").html(updatedcontent);
    });

    $("#add-question").on('click', '#addMultiChoiceOptionBtn', function (e) {

      $('#popmodal').trigger('click');
    });

    $("#add-question").on('click', '#popmodal', function (e) {

      if ($(this).data("istimed") == "TimedAssessment") {
        let currentText = $(".ql-editor");
        if (currentText.indexOf("_") > -1 || currentText.indexOf("_") > -1) {
          toastr.error("Only one inline option can be used per question.");
          $("#option-holder").html("<h5 style='color:darkred' class='text-center'>Only one inline option can be used per question.</h5>");
          $("#sb-holder").hide();
        } else {
          $("#sb-holder").show();
        }
      }
    });

    $("#option-holder").on('click', '.removeOption', function () {
      $(this).parent().parent().remove();
    });
    //listen to keypres events and pop the  add option modal
    $("#add-question").on('keydown', '.ql-editor', function (e) {
      //pop the multichoice modal
      // alert();


      if (e.key === '_') {
        $("#popmodal").trigger("click");
      }

    });

    $("#save-options").click(function () {
      // let options = $("#option-holder > .form-group");
      // if ( $("#option-holder").find(".isanswer:checked").length == 0) {
      //     toastr.error("Please select one option as the answer");
      //     return;
      // }
      // if ($("#option-holder").find(".option-item").length == 1) {
      //     toastr.error("Please enter more than one option for the dropdown");
      //     return;
      // }
      // console.log(options);
      // if (options.length > 0) {

      //     optionStorageCheck(options, 'impt-qtn-options', 2);
      //     $("#inlineOptionModal").modal("hide");
      //     toastr.info("Options saved.");
      // }
      // else {
      //     toastr.error("NO OPTIONS ENTERED");
      // }
    });

    $(".crt-new-qtn").click(function (e) {
      let numberofOptions = this.questionOptions; // JSON.parse(localStorage.getItem('impt-qtn-options'));

      if (numberofOptions) {
        if (numberofOptions.length > 0) {
          let remainder = $("#marks").val() % numberofOptions.length;
          if (remainder > 0) {
            e.preventDefault();
            toastr.error("Please ensure, the score can be evenly split between the number of options in the question");
            return;
          }
        }
      }




      $("#question").val($(".ql-editor").html());


      $("#redirectflag").val($(this).data("rdf"));
      // console.log( $(".ql-editor").html() );
      // console.log($("#question").val());
      // $("#optionsJSONString").val(localStorage.getItem(optionKey_));
      // if($("#option-m").val() == 1 && !localStorage.getItem(optionKey_)) {
      //     toastr.error("Please provide options or an Answer for the question");
      //     e.preventDefault();
      //}


    });


    // let optDisppane =  this.optiondisplayPane.nativeElement as HTMLElement;

    let updateCacheMethod = this.updateOptionCache;

    $(".optiondisplayPane").on('click', '.editable_option', function () {
      localStorage.setItem('oev', $(this).val());
    });

    $(".optiondisplayPane").on('change', '.editable_option', function () {
      if ($(this).val().length == 0) {
        $(this).val(localStorage.getItem('oev'));
      }
      else {
        updateCacheMethod("", 0, 1);
      }

    });


    function setLabels() {

    }



  }

  updateOptionText(optionItem, textValue){
    optionItem.option = textValue;
  }

  updateQuestionAnswer(optionGroupIndex, itemIndex){
    const options = this.questionOptions[optionGroupIndex];
    options.forEach((option) => {
      option.isAnswer = false;
    })
    options[itemIndex].isAnswer = 'true';
  }

  addNewOption(){
    this.optionsSetup.push(this.optionsSetup.length);
  }
  saveModalOptionClickHandler() {
    let optionHolder = this.optionsHolder.nativeElement as HTMLElement;
    let options = optionHolder.getElementsByClassName("fieldset");// $("#option-holder > .form-group");

    if ($("#option-holder").find(".isanswer:checked").length == 0) {
      toastr.error("Please select one option as the answer");
      return;
    }
    if ($("#option-holder").find(".option-item").length == 1) {
      toastr.error("Please enter more than one option for the dropdown");
      return;
    }

    if (options.length > 0) {
      this.optionStorageCheck(options, 'impt-qtn-options', 2);
      this.optionsSetup = []
      $("#closeModal").trigger("click");
    }
    else {
      toastr.error("NO OPTIONS ENTERED");
    }
  }

  optionStorageCheck(option_items: any, option_key: string, flag: number): QuestionOption[] {
    let questionOptionArray: any;
    let arrayOfOptions = [];
    let currentIndex = 0;
    let exisitngOptionsArray = [];
    //@*///check if a storage item already exist,
    ///if yes, get the count ,subtract by one to get the optionIndex
    ///add a new object to the existing options array, else create a new one*@
    // let previousOption =   localStorage.getItem(option_key);
    // let previousOption = this.questionOptions;
    //console.log(this.questionOptions);
    if (this.questionOptions != null) {
      //     console.log(previousOption)
      //     exisitngOptionsArray = JSON.parse(previousOption);
      //     console.log(exisitngOptionsArray)
      exisitngOptionsArray = this.questionOptions;
      currentIndex = this.questionOptions.length;
      // console.log(currentIndex);
      // console.log(this.questionOptions);
    }

    //flag 1 is for short answers
    if (flag === 1) {
      arrayOfOptions = [{
        option: $("#qtn-answer").val(),
        altoption: $("#qtn-alt-answer").val(),
        optionIndex: currentIndex
      }];
    } else {
      $.each(option_items, function (index, value) {
        let quilElement = $(value).find(".option-item");
        let quill = new Quill(quilElement[0]);
        let htmlContent = quill.root.innerHTML;
        arrayOfOptions[index] = {
          option: htmlContent,
          isAnswer: $(value).find(".isanswer:checked").val(),
          optionIndex: currentIndex
        }
      });
      //debugger;
    }
    //@* Save the Options in draft mode to be recalled whren the actual question is to be saved *@
    exisitngOptionsArray[currentIndex] = arrayOfOptions;
    //localStorage.setItem(option_key, JSON.stringify(exisitngOptionsArray));
    this.questionOptions = exisitngOptionsArray;
    questionOptionArray = exisitngOptionsArray;
    console.log(this.questionOptions)
    // console.log(this.questionOptions);
    return questionOptionArray;
  };

  updateOptionCache(val: string, optiongroupindex: number, optionindex: number) {
    //console.log(this.questionOptions);
  }



  ngAfterViewInit(): void {



    //let setQuestionForPosting = this.setQuestionForPosting.nativeElement as HTMLElement;
    // let editor = this.editor.nativeElement as HTMLElement;
    // let marksField = this.markField.nativeElement as HTMLInputElement;
    // let hiddentQuestionField = this.questionField.nativeElement as HTMLInputElement;



    // setQuestionForPosting.onclick = function(e){
    //           //console.log();
    //           let numberofOptions = JSON.parse(localStorage.getItem('impt-qtn-options'));

    //           //check if the scores match the entered scores
    //           if (numberofOptions) {
    //               if (numberofOptions.length > 0) {
    //                   let remainder = Number.parseInt(marksField.value) % numberofOptions.length;
    //                   if (remainder > 0) {
    //                       e.preventDefault();
    //                       toastr.error("Please ensure, the score can be evenly split between the number of options in the question");
    //                       return;
    //                   }
    //                 }
    //             }
    //             //move the ql editor html to the hidden field for actual poasting to server
    //             hiddentQuestionField.value = editor.getElementsByClassName("ql-editor").item(0).innerHTML;
    // }



  }





  removePlaceHolder(text: string, indexToRemove: number, replacementtext: string) {
    let substring1 = text.substring(0, indexToRemove);
    let substring2 = text.substring(indexToRemove + 1, text.length);

    return substring1 + replacementtext + substring2;
  }

  //SUBMIT THE QUESTIONS TO SERVER SIDE-----------------------
  addQuestion(text: string, marks: string) {
    //debugger;

    this.header.pageLoadingStarted(this);
    this.freezePage_formSubmissionInProgress = true;
    //this.toastr.info("Saving question...")

    let data: NewquestionModel;

    let redirectionFlag = this.redirectflag.nativeElement as HTMLInputElement;

    data = {
      id: this.questionData.id,
      sn: this.questionData.sno,
      assessmentid_: this.assessmentid,
      batchid:this.currentBatchID,
      marks_: marks,
      text: text,
      optionsJSONString: JSON.stringify(this.questionOptions)// localStorage.getItem(this.optionKey)
    }

    if (Number.parseFloat(marks) < 0) {
      this.toastr.warning("Please enter marks for this question", "Warning", { timeOut: 5000 });
      this.freezePage_formSubmissionInProgress = false;
      this.header.pageLoadingDone(this);
      return;

    }

    this.assesmentmanager.createAssessmentQuestion(data).toPromise().then(
      (data: any) => {
        this.toastr.success("Question Saved", "Success", { timeOut: 5000 });
        this.assessmentid = data;

        this.header.pageLoadingDone(this);

        if (redirectionFlag.value == "1") {
          this.router.navigate(['/user/assessmentdetails'], { queryParams: { classid: this.currentClassID,batchid:this.currentBatchID, aid: this.assessmentid } });
        } else {
          this.router.navigate(['/buffer'], { queryParams: { classid: this.currentClassID, batchid:this.currentBatchID, aid: this.assessmentid, target: this.assesmentmanager.bufferRoute.AddQuestion } });

        }

        this.freezePage_formSubmissionInProgress = false;

        //this.router.navigate(['/user/addquestion'], {queryParams:{aid:this.assessmentid,classid:this.currentClassID,target:this.assessmentmanager.bufferRoute.AddQuestion}});
      }
    ).catch((error) => {
      this.toastr.error('An error occured');
      this.header.pageLoadingDone(this);
    });

  }
  //SUBMIT THE QUESTIONS TO SERVER SIDE-----------------------

  clearOptionGroup(index: number) {

    let content = $(".ql-editor").html() as string;
    let pseudoUnderscore = "{}";
    let pseudoUnderscoreRegex = /{}/g;

    let foundItem = false;
    let occurenceCount = 0;
    let underscore_index = 0;

    /** when i get the first underscore
     * increment the occurence counter++
     * if occurence minus 1 equals the index parameter
     * then this means the current occurence is the one targeted by the index, so Remove it
     * else change the encountered underscore to psudounderscore so that the next iteration will move to the next occurence
     */


    do {
      underscore_index = content.indexOf("_");
      if (underscore_index > -1) {
        occurenceCount++;
      } else { foundItem = true };
      if ((occurenceCount - 1) == index) {
        content = this.removePlaceHolder(content, underscore_index, "");
        $(".ql-editor").html(content.replace(pseudoUnderscoreRegex, "_"));
        foundItem = true;
      } else {
        content = this.removePlaceHolder(content, underscore_index, pseudoUnderscore);
      }
    } while (foundItem == false);

    this.questionOptions.splice(index, 1);
    //localStorage.setItem(this.optionKey, JSON.stringify(this.questionOptions));
  }

  clearSpecificOption(groupindex: number, optionitemIndex: number) {
    if (this.questionOptions[groupindex].length > 2) {
      this.questionOptions[groupindex].splice(optionitemIndex, 1);
      //localStorage.setItem(this.optionKey, JSON.stringify(this.questionOptions));
    }
    else {
      this.toastr.warning("Unable to delete option. Questions must have at least two options");
    }
  }

  addMultiChoiceOption(){
    this.optionsSetup = [];
    this.optionsSetup.push( this.optionsSetup.length );
    this.optionsSetup.push( this.optionsSetup.length );
  }
}



